import { render, staticRenderFns } from "./CompanyFormDetailsEscalated.vue?vue&type=template&id=249691a4&scoped=true&"
import script from "./CompanyFormDetailsEscalated.vue?vue&type=script&lang=js&"
export * from "./CompanyFormDetailsEscalated.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFormDetailsEscalated.vue?vue&type=style&index=0&id=249691a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249691a4",
  null
  
)

export default component.exports